// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"5d9d7837","355":"c079c322","422":"3643bc39","444":"e3eab017","558":"b0e21a74","736":"ebeaa52d","742":"a01e1762","783":"966d1e40","882":"37905c38","954":"4fc0d8c0"}[chunkId] + ".chunk.js";
};